import { render, staticRenderFns } from "./domainSearch.vue?vue&type=template&id=04920b51&scoped=true&"
import script from "./domainSearch.vue?vue&type=script&lang=js&"
export * from "./domainSearch.vue?vue&type=script&lang=js&"
import style0 from "./domainSearch.vue?vue&type=style&index=0&id=04920b51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04920b51",
  null
  
)

export default component.exports